// The P&P flow seam.
//
// Fernando (2026-09-07): picking and packing must be doable in several ways —
// a new flow starts as admin-only "testing" and, once approved, is offered to
// the warehouse on the Orders page. Every round and every event carries its
// flow key, so flows can be compared in Statistics.
//
// Today there is exactly one flow. This file is where a second one plugs in:
// add a row to pp_flows (backend) and an entry here mapping the key to the
// components that implement it. Nothing else in the app needs to know.
import React from 'react';
import PickingWindow from '../PickingWindow';
import PackingSession from '../PackingSession';
import PackingWindow from '../PackingWindow';
import { authFetch, API } from '../api';

export interface PpFlow { key: string; label: string; status: 'testing' | 'approved' | 'retired'; is_default: boolean }

export interface FlowComponents {
  /** The picking walk for a set of orders. */
  Picking: React.ComponentType<{ orderIds: string[]; onClose: () => void; roundId?: number | null; picker?: string | null; cartId?: string | null; viewOnly?: boolean }>;
  /** The scan-driven packing session (Start packing with nothing selected). */
  PackingSession: React.ComponentType<{ onClose: () => void }>;
  /** Packing the orders ticked in the grid. */
  Packing: React.ComponentType<{ orderIds: string[]; onClose: () => void }>;
}

export const FLOWS: Record<string, FlowComponents> = {
  default: { Picking: PickingWindow, PackingSession, Packing: PackingWindow },
};

export function flowComponents(key: string): FlowComponents {
  return FLOWS[key] || FLOWS.default;
}

export function selectedFlowKey(): string {
  try { return localStorage.getItem('wms_pp_flow') || 'default'; } catch { return 'default'; }
}

export function setSelectedFlowKey(key: string) {
  try { localStorage.setItem('wms_pp_flow', key); } catch { /* ignore */ }
}

export async function loadFlows(): Promise<{ flows: PpFlow[]; default: string; is_device: boolean }> {
  const r = await authFetch(`${API}/pp/flows`);
  if (!r.ok) return { flows: [{ key: 'default', label: 'Default P&P', status: 'approved', is_default: true }], default: 'default', is_device: false };
  return r.json();
}
